import React from 'react';
import { SectionTitle, Form } from '@yuhuinc/ui-library';
import { Button, Input, Space, Switch } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { requiredRule } from '../common/Rules';
import { ContentWrapper, InlineFormItem } from '../common/StyledComponents';
import { useDrawerState } from 'ui-library';
import IncentiveCodeDrawer from './IncentiveCodeDrawer';
import IncentiveCodesTable from './IncentiveCodesTable';
const { TextArea } = Input;

const maybeRenderExternalFields = (externally_visible) => {
  const [, incentiveCodeDrawer] = useDrawerState(false);

  if (!externally_visible) {
    return null;
  }

  return (
    <>
      <Form.Item
        name="external_name"
        label={getTranslatedString('landlordPortal.incentives.externalName')}
        rules={[requiredRule]}
        hasFeedback
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="external_description"
        label={getTranslatedString('landlordPortal.incentives.externalDescription')}
        rules={[requiredRule]}
        hasFeedback
      >
        <Input />
      </Form.Item>

      <SectionTitle>{getTranslatedString('landlordPortal.incentives.incentiveCodes')}</SectionTitle>

      <Form.List name="incentive_codes">
        {(fields, operations) => {
          return (
            <Space direction="vertical" size="middle">
              {fields.length ? (
                <IncentiveCodesTable codes={fields} operations={operations} />
              ) : null}

              <div>
                <Button type="secondary" onClick={incentiveCodeDrawer.open}>
                  {getTranslatedString('landlordPortal.incentives.addACode')}
                </Button>
              </div>

              <IncentiveCodeDrawer drawer={incentiveCodeDrawer} onAdd={operations.add} />
            </Space>
          );
        }}
      </Form.List>
    </>
  );
};

const Name = () => {
  const incentivesForm = Form.useFormInstance();
  const externally_visible = Form.useWatch('externally_visible', incentivesForm);

  return (
    <ContentWrapper>
      <SectionTitle>{getTranslatedString('landlordPortal.incentives.name')}</SectionTitle>

      <Form.Item
        name="internal_name"
        label={getTranslatedString('landlordPortal.incentives.internalName')}
        rules={[requiredRule]}
        hasFeedback
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="internal_description"
        label={getTranslatedString('landlordPortal.incentives.internalDescription')}
        rules={[requiredRule]}
        hasFeedback
      >
        <TextArea />
      </Form.Item>

      <Form.Item
        name="internal_code"
        label={getTranslatedString('landlordPortal.incentives.internalCode')}
        rules={[requiredRule]}
        hasFeedback
      >
        <Input />
      </Form.Item>

      <InlineFormItem
        name="externally_visible"
        label={getTranslatedString('landlordPortal.incentives.externallyVisible')}
        valuePropName="checked"
      >
        <Switch />
      </InlineFormItem>

      {maybeRenderExternalFields(externally_visible)}
    </ContentWrapper>
  );
};

export default Name;
